import router from '../router'

// 删除搜索缓存
export function deleteSearchsStorage() {
  localStorage.removeItem('430cacheSearch')
}
// 获取搜索缓存
export function getSearchsStorage(key = router.history.current.name) {
  try {
    let cacheInfo = localStorage.getItem('430cacheSearch')
      ? JSON.parse(localStorage.getItem('430cacheSearch'))
      : ''
    return cacheInfo[key] ? cacheInfo[key] : ''
  } catch (err) {
    return null
  }
}
// 设置搜索缓存
export function setSearchsStorage(value, key = router.history.current.name) {
  try {
    let cacheInfo = localStorage.getItem('430cacheSearch')
      ? JSON.parse(localStorage.getItem('430cacheSearch'))
      : {}
    cacheInfo[key] = value
    localStorage.setItem('430cacheSearch', JSON.stringify(cacheInfo))
  } catch (err) {
    console.log(' err' + err)

    return null
  }
}
